export enum HightlightCardStatus {
  neutral = 'neutral',
  success = 'success',
  error = 'error',
}

export interface HighlightCardProps {
  className?: string;
  testId?: string;
  text: string;
  status?: HightlightCardStatus;
  value: number | string | null | undefined;
  unit: string;
}
